import { useContext } from "react";
import { ListingsMatchContext } from "contexts/ListingsMatchContext";
import type { SearchState } from "contexts/ListingsMatchContext";
import { useTranslation } from "react-i18next";
import { AutocompleteMultiSelect } from "components/__haim/Common/AutocompleteMultiSelect";
import { SyntheticEvent } from "react";
import { AutocompleteInputChangeReason } from "@material-ui/core";
import { useSellerNames } from "hooks/useSellerNames";

type SellerNamesPickerProps = {
  draftSearchState?: SearchState;
  setDraftSearchState?: (s: Partial<SearchState>) => void;
};

export function SellerNamesPicker(props: SellerNamesPickerProps = {}) {
  const { t: translate } = useTranslation();

  const { sellerNames, loading, setSearch } = useSellerNames();

  const ctx = useContext(ListingsMatchContext);
  const draftSearchState = props.draftSearchState ?? ctx?.draftSearchState;
  const setDraftSearchState = props.setDraftSearchState ?? ctx?.setDraftSearchState;

  const handleSearchChange = (
    event: SyntheticEvent,
    newValue: string,
    reason: AutocompleteInputChangeReason
  ) => {
    if (reason !== "input") return;

    setSearch(newValue);
  };

  return (
    <AutocompleteMultiSelect
      label={translate("listingsMatch.filters.sellerNamesTitle")}
      emptyLabel={translate("listingsMatch.filters.allOptions")}
      value={draftSearchState.sellerNames}
      options={sellerNames}
      loading={loading}
      onChange={(value) => setDraftSearchState({ sellerNames: value })}
      onInputChange={handleSearchChange}
    />
  );
}
